import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from "@/plugins/translations/t";
import {t} from "@/plugins/translations/t";

Vue.prototype.$t = t;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
// @ts-ignore
  i18n,
  render: h => h(App)
}).$mount('#app')
